import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-420016ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-fail-view" }
const _hoisted_2 = { class: "payment-fail-view__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-fail-view__description" }, [
  /*#__PURE__*/_createTextVNode(" Оплата не проведена:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Отказ банка – эмитента карты."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Ошибка в процессе оплаты, указаны неверные данные карты. ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "payment-fail-view__additional"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentResultPanel = _resolveComponent("PaymentResultPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaymentResultPanel, null, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, " Ошибка оплаты заказа №" + _toDisplayString(_ctx.orderID), 1),
        _hoisted_3,
        (_ctx.order?.payment?.statusDescription)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.order.payment.statusDescription), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}